import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './WarningBanner.module.scss';
import { translate } from '@chaika/i18n/helper';
import WarningIcon from '@components/Icon/svg/warning.svg';
import CheckIcon from '@components/Icon/svg/check_redesign.svg';
import CrossIcon from '@components/Icon/svg/cross.svg';

interface Props {
    children: ReactNode;
    theme?: WarningBannerTheme;
    modifiers?: WarningBannerModifiers[];
    dataTest?: string;
    onClose?: () => void;
}

export enum WarningBannerTheme {
    // @ts-ignore
    Error = styles.error,
    // @ts-ignore
    Success = styles.success,
}

export enum WarningBannerModifiers {
    // @ts-ignore
    Rounded = styles.rounded,
}

export function WarningBanner({ children, theme, modifiers = [], dataTest, onClose }: Props) {
    const isSuccess = theme === WarningBannerTheme.Success;

    return (
        <div
            className={classNames([styles.root, theme, ...modifiers])}
            data-test={dataTest}
        >
            <span className={styles.icon}>{isSuccess ? <CheckIcon /> : <WarningIcon />}</span>
            <span className={styles.text}>{children}</span>
            {onClose && (
                <button
                    type="button"
                    className={styles.close}
                    onClick={onClose}
                    aria-label={translate('close')}
                >
                    <CrossIcon />
                </button>
            )}
        </div>
    );
}
